/**
 *
 *
 */
app.directive('dynamicAreaSelectDropdown', ["$rootScope", "$http", "$timeout", function($rootScope, $http, $timeout) {

	return {

		restrict: 'EA',
		templateUrl: 'dynamic-area-select-dropdown.html',
		scope: {
			'myId': '@id',
			'query': '=queryObject', // query can be of type QueryObject or...,
			'areaDataSource': '@'
		},
		link: function(scope, element, attrs) {

			scope.addressSearch = {
				suggestions: [
					{
						type: "region",
						name: "Lääni",
						values: []
					},
					{
						type: "county",
						name: "Maakunta",
						values: []
					},
					{
						type: "municipality",
						name: "Kunta",
						values: []
					},
					{
						type: "city",
						name: "Kaupunki",
						values: []
					},
					{
						type: "district",
						name: "Kaupunginosa/alue",
						values: []
					},
					{
						type: "address",
						name: "Osoite",
						values: []
					},
					{
						type: "postcode",
						name: "Postinumero",
						values: []
					}
				],
				input: "",
				active: 0
			};

			scope.elementWidth = element[0].offsetWidth;
			scope.fontSize = parseFloat(window.getComputedStyle(element[0], null).getPropertyValue('font-size'));

			$timeout(function() {
				scope.elementWidth = element[0].offsetWidth;
				scope.fontSize = parseFloat(window.getComputedStyle(element[0], null).getPropertyValue('font-size'));
			});

			window.addEventListener("resize", function(evt) {
				scope.elementWidth = element[0].offsetWidth;
				scope.fontSize = parseFloat(window.getComputedStyle(element[0], null).getPropertyValue('font-size'));
			});
		},

		controller: ["$scope", "$http", function($scope, $http) {

			$scope.$watch('addressSearch.input', function(newVal) {
				if(newVal !== "") {
					$scope.GetAddressSuggestions(newVal);
				}
			});


			function getAddressSuggestionsCount() {
				var count = 0;
				for(var i = 0; i < $scope.addressSearch.suggestions.length; i++) {
					count += $scope.addressSearch.suggestions[i].values.length;
				}
				return count;
			}


			function getAddressByAssignedIndex(index) {
				for(var i = 0; i < $scope.addressSearch.suggestions.length; i++) {
					var addressType = $scope.addressSearch.suggestions[i].type;
					var subAddrArray = $scope.addressSearch.suggestions[i].values;
					for(var j = 0; j < subAddrArray.length; j++) {
						if(subAddrArray[j].index == index) {
							return subAddrArray[j];
						}
					}
				}
				return undefined;
			}




			$scope.GetSearchAreaText = function() {
				var addressString = "Valitse alue";
				if($scope.query.GetAddressConstraints().length > 0) {
					addressString = "";

					for(var i = 0; i < $scope.query.GetAddressConstraints().length; i++) {
						addressString += $scope.query.GetAddressConstraints()[i].value;
						if(i != $scope.query.GetAddressConstraints().length - 1) {
							addressString += ", ";
						}
					}

					// Approximation to enable variable length strings in the dropdown selected text.
					var maxStringChars = Math.floor($scope.elementWidth / ($scope.fontSize * 0.5));

					addressString = addressString.length > maxStringChars ? addressString.substr(0, maxStringChars-1) + "…" : addressString;
				}

				return addressString;

			};

			$scope.HandleAreaDropdownKeyPress = function(event) {

				// Up
				if(event.which == 38) {
					$scope.addressSearch.active = $scope.addressSearch.active > 0 ? $scope.addressSearch.active - 1 : getAddressSuggestionsCount() - 1;
				}
				// Down
				else if(event.which == 40) {
					$scope.addressSearch.active = $scope.addressSearch.active < getAddressSuggestionsCount() - 1 ? $scope.addressSearch.active + 1 : 0;
				}
				// Enter
				else if(event.which == 13) {
					if($scope.addressSearch.input.length > 0) {
						$scope.AddSearchAddress(getAddressByAssignedIndex($scope.addressSearch.active), event);
					}
				}
				// ESC
				else if(event.which == 27) {

				}
				else {
					$scope.addressSearch.active = 0;
				}
			};

			$scope.AddSearchAddress = function(address, event) {
				if(typeof(address) == 'undefined') {
					return false;
				}
				event.preventDefault();
				event.stopPropagation();
				$scope.query.AddAddressConstraint(address);
				$scope.addressSearch.input = "";
				for(var i = 0; i < $scope.addressSearch.suggestions.length; i++) {
					$scope.addressSearch.suggestions[i].values.length = 0;
				}
				$scope.addressSearch.active = -1;
			};

			$scope.RemoveSearchAddress = function(index, event) {
				event.preventDefault();
				event.stopPropagation();
				$scope.query.RemoveAddressConstraint(index);
			};

			$scope.GetAddressSuggestions = function(text) {

				var params = {
					key: text,
					limit: 50
				};

				if($scope.areaDataSource == "online-offer") {
					params.type = "SaleProperty";
				}

				$http({
					method: 'GET',
					url: '/api/km/KM/search',
					params: params
				}).then(function(results, status, headers, config) {
					ParseAddressSuggestions(results.data.data.results);
					// todo: kun 0, antamallasi hakusanalla ei löytynyt kohteita
				}, function(data, status, headers, config) {
					console.log("error getting address suggestions:", data);
				});
			};

			function ParseAddressSuggestions(suggestions) {

				for(var i = 0; i < $scope.addressSearch.suggestions.length; i++) {
					var addressType = $scope.addressSearch.suggestions[i].type;
					var addressTypeName = $scope.addressSearch.suggestions[i].name;
					$scope.addressSearch.suggestions[i].values.length = 0;
					for(var j = 0; j < suggestions.length; j++) {
						if(suggestions[j].type == addressType) {
							suggestions[j].index = j;
							suggestions[j].parsedValue = suggestions[j].value + ", " + addressTypeName;
							$scope.addressSearch.suggestions[i].values.push(suggestions[j]);
						}
					}
				}

				// Resetoidaan aktiivinen arvo aina kun on haettu uusi setti osoite-ehdotuksia.
				if(suggestions.length > 0) {
					$scope.addressSearch.active = 0;
				}
				else {
					$scope.addressSearch.active = -1;
				}
			}
		}]
	};

}]);

